module.exports = __webpack_public_path__ + "static/media/languageIcon.67a4f6d7.svg";